import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const StatusProgressContainer = styled.div`
    padding: 24px 20px;
`;

export const StatusProgressList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StatusProgressStep = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
`;

export const StatusProgressStepIcon = styled.div`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
`;

export const StatusProgressStepContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const StatusProgressStepTitle = styled.div`
    font-family: Circular;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.265;
    color: ${colors.darkGray1};
    margin-bottom: 2px;
`;

export const StatusProgressStepDescription = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 13px;
    line-height: 1.385;
    color: ${colors.darkGray3};
`; 